import { Box, Image, VStack } from "@chakra-ui/react";

export const Bottomimg = () => {
  return (
    <VStack bgColor={"#f2f4f6"} gap={"15px"} pb={"15px"}>
      <Box w={"fit-content"}>
        <Image
          src={
            "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_3200/t_high_res_template/categories/category_v2/category_a4e46fa0.png"
          }
          h={"-moz-max-content"}
        />
      </Box>
      <Box w={"fit-content"}>
        <Image
          src={
            "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_3200/t_high_res_template/images/growth/home-screen/1624344861242-558286.png"
          }
        />
      </Box>
      <Box w={"fit-content"}>
        <Image
          src={
            "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_3200/t_high_res_template/categories/category_v2/category_3cffdf20.png"
          }
        />
      </Box>
    </VStack>
  );
};
